<template>
  <div class="app-paginate">
    <div class="app-paginate-info">
      {{ $t('paginate.showing') }} {{ minRows }} {{ $t('paginate.to') }} {{ maxRows }} {{ $t('paginate.of') }} {{ pageable.totalElements }}
      {{ $t('paginate.entries') }}
    </div>
    <v-pagination v-if="!hidePaginate" v-model="currentPage" :total-visible="12" :length="pageable.totalPages" />
  </div>
</template>

<script>
import { debounce } from 'lodash';
export default {
  name: 'TableFooter',
  props: {
    pagingTable: {
      type: Number,
      default: 0
    },
    hidePaginate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pageable() {
      return this.$store.getters['table/pageableById'](this.pagingTable);
    }
  },
  data: () => ({
    currentPage: 1,
    maxRows: 0,
    minRows: 0
  }),
  watch: {
    currentPage(val) {
      if (val !== this.pageable.currentPage) {
        this.$store.commit('table/SET_DEFAULT_CURRENT_PAGE', val);
        this.movePage();
      }
    },
    pageable: {
      deep: true,
      handler() {
        this.currentPage = this.pageable.currentPage;
        this.calculateMinMax(this.currentPage);
      }
    }
  },
  methods: {
    movePage: debounce(function() {
      this.$emit('fetch');
    }, 500),

    calculateMinMax(val) {
      this.maxRows = val * this.pageable.limit <= this.pageable.totalElements ? val * this.pageable.limit : this.pageable.totalElements;
      this.minRows =
        val * this.pageable.limit <= this.pageable.totalElements
          ? this.maxRows - this.pageable.limit + 1
          : (this.pageable.currentPage - 1) * this.pageable.limit + 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.app-paginate {
  font-family: Montserrat;
  padding: 15px;

  &-info {
    font-weight: 500;
    font-size: 12px;
    color: #6d6d6d;
    text-align: center;
    margin-bottom: 15px;
  }

  @include query-min-sm() {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-info {
      margin-bottom: 0;
      text-align: left;
    }
  }
}
</style>
